// import library
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate, useParams } from "react-router-dom";

// import component
import Layout from "../../layouts/Layout";
import LoaderIcon from "../../components/Common/Icon/Loader";

// import files
import DatePickerComponent from "../../components/Profile/Field/DatePickerComponent";
import TimePickerComponent from "../../components/Profile/Field/TimePickerComponent";

// files
import { env } from "../../env";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import WarningPopUp from "../../components/Profile/WarningPopUp";
import { AuthContext } from "../../context";

const EditTask = () => {
    // variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const storedVisitData = localStorage.getItem('visit');
    const initialVisitData = storedVisitData ? JSON.parse(storedVisitData) : {};
    const [visitTypeData, setVisitTypeData] = useState(initialVisitData);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    
    const [isLoader, setIsLoader] = useState(true);
    const { id, customerId } = useParams();
    const [inputs, setInputs] = useState({});

    const [showLibrary, setShowLibrary] = useState(false);
    const [showCategory, setShowCategory] = useState(false);
    const [showImportance, setShowImportance] = useState(false);
    const [showOutCome, setShowOutCome] = useState(false);
    const [showMultiChoice1, setShowMultiChoice1] = useState(false);
    const [showMultiChoice2, setShowMultiChoice2] = useState(false);
    const [showMultiChoice3, setShowMultiChoice3] = useState(false);
    const [showMultiChoice4, setShowMultiChoice4] = useState(false);
    const [showMultiChoice5, setShowMultiChoice5] = useState(false);
    const [showMasterList1, setShowMasterList1] = useState(false);
    const [showMasterList2, setShowMasterList2] = useState(false);
    const [showMasterList3, setShowMasterList3] = useState(false);
    const [showMasterList4, setShowMasterList4] = useState(false);
    const [showMasterList5, setShowMasterList5] = useState(false);

    const [taskTemplate, setTaskTemplate] = useState({});

    // file
    const [files, setFiles] = useState([]);
    const [error, setError] = useState('');

    const [file1, setFile1] = useState("");
    const [file1Name, setFile1Name] = useState("");
    const [file1Size, setFile1Size] = useState(0);
    const [error1, setError1] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    // multichoice
    const [selectedIds1, setSelectedIds1] = useState([]);
    const [selectedIds2, setSelectedIds2] = useState([]);
    const [selectedIds3, setSelectedIds3] = useState([]);
    const [selectedIds4, setSelectedIds4] = useState([]);
    const [selectedIds5, setSelectedIds5] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            getTaskDetailApi(baseUrl, token);
        };
        fetchData();
    }, []);

    // tab change
    const handleTabCheckDataFromChild = (data) => {
        if((visitTypeData && visitTypeData.visitId) && data.tab === 'profile') {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            if(data.link === '/logout') {
                authContext.logout();
            } else {
                navigate(data.link);
            }
            localStorage.removeItem("profile_tab");
        }
    };
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };
    // Helper function to convert image URL to Base64
    const convertAttachmentsToBase64 = async(attachments) => {
        for (let attachment of attachments) {
            if (attachment.imagepath) {
                try {
                    const base64String = await imageToBase64(attachment.imagepath);
                    attachment.image = base64String; // Store Base64 in the image field
                } catch (error) {
                    console.error(`Error converting image for ID ${attachment.imageid}:`, error);
                }
            }
        }
        return attachments;
    };
    const imageToBase64 = (imageUrl) => {
        return fetch(imageUrl)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result); // Base64 string
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            }));
    };
    const getTitleById = (masterList, id) => {
        if (!Array.isArray(masterList) || masterList.length === 0) {
            return "List is empty";
        }
        
        if (typeof id !== "number" || id <= 0) {
            return "";
        }
        
        const item = masterList.find(item => item.id === id);
        return item ? item.title : "";
    };
    // data
    const getTaskDetailApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Transaction/GetTask?taskid=${id}`,{ headers })
        .then((response) => {
            const taskTemplate = response.data;
            setTaskTemplate(response.data);
            convertAttachmentsToBase64(taskTemplate.attachments).then(updatedAttachments => {
                setInputs((prevData) => ({
                    ...prevData,
                    attachments: updatedAttachments
                }));
                setFiles(updatedAttachments);
            });

            setInputs((prevData) => ({
                ...prevData,
                id: id,
                description: taskTemplate.description,
                fromdate: taskTemplate.fromDate,
                todate: taskTemplate.toDate,
                fromtime: taskTemplate.fromTime,
                totime: taskTemplate.toTime,
                duration: taskTemplate.duration,
                importanceid: taskTemplate.importanceID,
                importanceName: taskTemplate.importanceName,
                outcomeid: taskTemplate.outComeID,
                outComeName: taskTemplate.outComeName,
                rate: taskTemplate.rate,
                singlevalue: taskTemplate.singleValue,
                comments: taskTemplate.comments,
                yesno: taskTemplate.yesNo,
                complitionlevel: taskTemplate.complitionLevel,
                userid: authContext.userInfo.id ? authContext.userInfo.id : "",
                username: authContext.userInfo.userName ? authContext.userInfo.userName : "",
                statusid: 0,
                mobileappversion: "",
                usermacaddress: "",
                apiversion: "",
                company_id: authContext.userInfo.userCompany ? authContext.userInfo.userCompany : "",
                tasktemplateid: taskTemplate.taskTemplateID,
                code: taskTemplate.code,
                singlevaluecaption: taskTemplate.singleValueCaption,
                yesnocaption: taskTemplate.yesNoCaption,
                text1value: taskTemplate.text1,
                text2value: taskTemplate.text2,
                text3value: taskTemplate.text3,
                text4value: taskTemplate.text4,
                text5value: taskTemplate.text5,
                integer1: taskTemplate.integer1,
                integer2: taskTemplate.integer2,
                integer3: taskTemplate.integer3,
                integer4: taskTemplate.integer4,
                integer5: taskTemplate.integer5,
                decimal1: taskTemplate.decimal1,
                decimal2: taskTemplate.decimal2,
                decimal3: taskTemplate.decimal3,
                decimal4: taskTemplate.decimal4,
                decimal5: taskTemplate.decimal5,
                date1value: taskTemplate.date1,
                date2value: taskTemplate.date2,
                date3value: taskTemplate.date3,
                date4value: taskTemplate.date4,
                date5value: taskTemplate.date5,
                mastersublist1value: taskTemplate.masterList1,
                mastersublist2value: taskTemplate.masterList2,
                mastersublist3value: taskTemplate.masterList3,
                mastersublist4value: taskTemplate.masterList4,
                mastersublist5value: taskTemplate.masterList5,
                masterList1Name: getTitleById(taskTemplate.masterList, taskTemplate.masterList1),
                masterList2Name: getTitleById(taskTemplate.masterList, taskTemplate.masterList2),
                masterList3Name: getTitleById(taskTemplate.masterList, taskTemplate.masterList3),
                masterList4Name: getTitleById(taskTemplate.masterList, taskTemplate.masterList4),
                masterList5Name: getTitleById(taskTemplate.masterList, taskTemplate.masterList5),
                libraryid: taskTemplate.libraryID,
                libraryName: taskTemplate.libraryName,
                categoryid: taskTemplate.taskCategoryID,
                taskCategoryName: taskTemplate.taskCategoryName,
                customerid: customerId,
                checkboxvalue1: taskTemplate.checkBox1value,
                checkboxvalue2: taskTemplate.checkBox2value,
                checkboxvalue3: taskTemplate.checkBox3value,
                checkboxvalue4: taskTemplate.checkBox4value,
                checkboxvalue5: taskTemplate.checkBox5value,
                barcode: "",
                timestamp: "",
                ismoneycollectiontask: taskTemplate.isMoneyCollectionTask,
                latitude: "",
                longitude: "",
                multichoicelist1: taskTemplate.multiChoiceTypeList1 ? taskTemplate.multiChoiceTypeList1 : [],
                multichoicelist2: taskTemplate.multiChoiceTypeList2 ? taskTemplate.multiChoiceTypeList2 : [],
                multichoicelist3: taskTemplate.multiChoiceTypeList3 ? taskTemplate.multiChoiceTypeList3 : [],
                multichoicelist4: taskTemplate.multiChoiceTypeList4 ? taskTemplate.multiChoiceTypeList4 : [],
                multichoicelist5: taskTemplate.multiChoiceTypeList5 ? taskTemplate.multiChoiceTypeList5 : [],
                ismultichoice1visible: taskTemplate.isMultiChoice1Visible,
                ismultichoice2visible: taskTemplate.isMultiChoice2Visible,
                ismultichoice3visible: taskTemplate.isMultiChoice3Visible,
                ismultichoice4visible: taskTemplate.isMultiChoice4Visible,
                ismultichoice5visible: taskTemplate.isMultiChoice5Visible,
                multichoice1caption: taskTemplate.multiChoice1Caption,
                multichoice2caption: taskTemplate.multiChoice2Caption,
                multichoice3caption: taskTemplate.multiChoice3Caption,
                multichoice4caption: taskTemplate.multiChoice4Caption,
                multichoice5caption: taskTemplate.multiChoice5Caption,
                multichoice1type: taskTemplate.multiChoice1Type,
                multichoice2type: taskTemplate.multiChoice2Type,
                multichoice3type: taskTemplate.multiChoice3Type,
                multichoice4type: taskTemplate.multiChoice4Type,
                multichoice5type: taskTemplate.multiChoice5Type
            }));
            
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            setIsLoader(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    // other files
    const handleChange = (e) => {
        const { name, value, checked } = e.target;
        if (name === 'checkboxvalue1' || name === 'checkboxvalue2' || name === 'checkboxvalue3' || name === 'checkboxvalue4' || name === 'checkboxvalue5') {
            setInputs((prevData) => ({
                ...prevData,
                [name]: checked ? 1 : 0,
            }));
        } else {
            setInputs((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };
    // handle files
    const handleFileInputChange = (event) => {
        setError("");
        const selectedFiles = Array.from(event.target.files); // Convert the file list to an array
    
        selectedFiles.forEach((file) => {
            const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'application/msword'];
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            
            // Check file type
            if (!allowedTypes.includes(file.type)) {
                setError('Invalid file format. Allowed formats are .pdf, .png, .jpg, .jpeg, .doc');
                return;
            }
    
            // Check file size
            if (file.size > maxSize) {
                setError('File size exceeds 10MB');
                return;
            }
    
            // Convert file to Base64
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1]; // Remove data URL prefix
                setFiles((prevFiles) => [
                    ...prevFiles,
                    {
                        imageid: 0,              // Always 0 for all files
                        image: base64String,     // Store base64 string
                        imagepath: null,         // Set imagepath to null
                        filename: file.name,     // Store the filename
                    }
                ]);

                setInputs((prevData) => ({
                    ...prevData,
                    attachments: [
                        ...prevData.attachments, // Retain existing attachment
                        {
                            imageid: 0,          // Always 0 for all files
                            image: base64String, // Store base64 string
                            imagepath: null,     // Set imagepath to null
                            filename: file.name, // Store the filename
                        },
                    ],
                }));
            };
    
            reader.readAsDataURL(file); // Read the file as a data URL
        });
    };
    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));

        setInputs((prevData) => ({
            ...prevData,
            attachments: prevData.attachments.filter((_, i) => i !== index),
        }));
    };
    const handleImageChange = (e) => {
        setError("");
        const selectedFile = e.target.files[0];
        
        if (selectedFile) {
            const allowedTypes = ['image/png', 'image/jpeg'];
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            
            // Check file type
            if (!allowedTypes.includes(selectedFile.type)) {
                setError1('Invalid file format. Allowed formats are .png, .jpg, .jpeg');
                setFile1(null);
                setFile1Name('');
                setFile1Size(0);
                setImagePreview(null);
                return;
            }

            // Check file size
            if (selectedFile.size > maxSize) {
                setError1('File size exceeds 10MB');
                setFile1(null);
                setFile1Name('');
                setFile1Size(0);
                setImagePreview(null);
                return;
            }

            // Convert the file to Base64
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1]; // Remove data URL prefix
                setFile1(base64String);  // Store Base64 string
                setFile1Name(selectedFile.name);
                setFile1Size(selectedFile.size);
                setImagePreview(reader.result);
            };

            reader.readAsDataURL(selectedFile);
        }
    };
    // handle date and time
    const handleDateDataFromChild = (data) => {
        setInputs((prevData) => ({
            ...prevData,
            [data.name]: data.date,
        }));
    };
    const handleTimeDataFromChild = (data) => {
        setInputs((prevData) => ({
            ...prevData,
            [data.name]: data.time,
        }));
    };
    // other drop down
    const handleLibrary = (e, value) => {
        e.preventDefault();
        setShowLibrary(!showLibrary);
        setInputs((prevData) => ({
            ...prevData,
            libraryID: value.id,
            libraryName: value.title
        }));
    };
    const handleCategory = (e, value) => {
        e.preventDefault();
        setShowCategory(!showCategory);
        setInputs((prevData) => ({
            ...prevData,
            taskCategoryID: value.id,
            taskCategoryName: value.title
        }));
    };
    const handleImportance = (e, value) => {
        e.preventDefault();
        setShowImportance(!showImportance);
        setInputs((prevData) => ({
            ...prevData,
            importanceID: value.id,
            importanceName: value.title
        }));
    };
    const handleOutCome = (e, value) => {
        e.preventDefault();
        setShowOutCome(!showOutCome);
        setInputs((prevData) => ({
            ...prevData,
            outComeID: value.id,
            outComeName: value.title
        }));
    };
    // handle multi choice by single select drop down
    const handleMultiChoiceTypeList1 = (e, value) => {
        e.preventDefault();
        setShowMultiChoice1(!showMultiChoice1);
        setInputs((prevData) => ({
            ...prevData,
            multichoicelist1: [value.id],
            MultiChoiceTypeList1Name: value.title
        }));
    };
    const handleMultiChoiceTypeList2 = (e, value) => {
        e.preventDefault();
        setShowMultiChoice2(!showMultiChoice2);
        setInputs((prevData) => ({
            ...prevData,
            multichoicelist2: [value.id],
            MultiChoiceTypeList2Name: value.title
        }));
    };
    const handleMultiChoiceTypeList3 = (e, value) => {
        e.preventDefault();
        setShowMultiChoice3(!showMultiChoice3);
        setInputs((prevData) => ({
            ...prevData,
            multichoicelist3: [value.id],
            MultiChoiceTypeList3Name: value.title
        }));
    };
    const handleMultiChoiceTypeList4 = (e, value) => {
        e.preventDefault();
        setShowMultiChoice4(!showMultiChoice4);
        setInputs((prevData) => ({
            ...prevData,
            multichoicelist4: [value.id],
            MultiChoiceTypeList4Name: value.title
        }));
    };
    const handleMultiChoiceTypeList5 = (e, value) => {
        e.preventDefault();
        setShowMultiChoice5(!showMultiChoice5);
        setInputs((prevData) => ({
            ...prevData,
            multichoicelist5: [value.id],
            MultiChoiceTypeList5Name: value.title
        }));
    };
    // handle master list drop down
    const handleMasterList1 = (e, value) => {
        e.preventDefault();
        setShowMasterList1(!showMasterList1);
        setInputs((prevData) => ({
            ...prevData,
            mastersublist1value: value.id,
            masterList1Name: value.title
        }));
    };
    const handleMasterList2 = (e, value) => {
        e.preventDefault();
        setShowMasterList2(!showMasterList2);
        setInputs((prevData) => ({
            ...prevData,
            mastersublist2value: value.id,
            masterList2Name: value.title
        }));
    };
    const handleMasterList3 = (e, value) => {
        e.preventDefault();
        setShowMasterList3(!showMasterList3);
        setInputs((prevData) => ({
            ...prevData,
            mastersublist3value: value.id,
            masterList3Name: value.title
        }));
    };
    const handleMasterList4 = (e, value) => {
        e.preventDefault();
        setShowMasterList4(!showMasterList4);
        setInputs((prevData) => ({
            ...prevData,
            mastersublist4value: value.id,
            masterList4Name: value.title
        }));
    };
    const handleMasterList5 = (e, value) => {
        e.preventDefault();
        setShowMasterList5(!showMasterList5);
        setInputs((prevData) => ({
            ...prevData,
            mastersublist5value: value.id,
            masterList5Name: value.title
        }));
    };
    const handleMultiCheckbox1Change = (event) => {
        const checkedId = parseInt(event.target.value);

        let categoryId = [];
        if (event.target.checked){
            setSelectedIds1([...selectedIds1,checkedId])
            categoryId = [...selectedIds1,checkedId];
        } else {
            setSelectedIds1(selectedIds1.filter(id=>id !== checkedId))
            categoryId = selectedIds1.filter(id=>id !== checkedId)
        }

        setInputs((prevData) => ({
            ...prevData,
            multichoicelist1: categoryId,
        }));
    };
    const handleMultiCheckbox2Change = (event) => {
        const checkedId = parseInt(event.target.value);

        let categoryId = [];
        if (event.target.checked){
            setSelectedIds2([...selectedIds2,checkedId])
            categoryId = [...selectedIds2,checkedId];
        } else {
            setSelectedIds2(selectedIds2.filter(id=>id !== checkedId))
            categoryId = selectedIds2.filter(id=>id !== checkedId)
        }

        setInputs((prevData) => ({
            ...prevData,
            multichoicelist2: categoryId,
        }));
    };
    const handleMultiCheckbox3Change = (event) => {
        const checkedId = parseInt(event.target.value);

        let categoryId = [];
        if (event.target.checked){
            setSelectedIds3([...selectedIds3,checkedId])
            categoryId = [...selectedIds3,checkedId];
        } else {
            setSelectedIds3(selectedIds3.filter(id=>id !== checkedId))
            categoryId = selectedIds3.filter(id=>id !== checkedId)
        }

        setInputs((prevData) => ({
            ...prevData,
            multichoicelist3: categoryId,
        }));
    };
    const handleMultiCheckbox4Change = (event) => {
        const checkedId = parseInt(event.target.value);

        let categoryId = [];
        if (event.target.checked){
            setSelectedIds4([...selectedIds4,checkedId])
            categoryId = [...selectedIds4,checkedId];
        } else {
            setSelectedIds4(selectedIds4.filter(id=>id !== checkedId))
            categoryId = selectedIds4.filter(id=>id !== checkedId)
        }

        setInputs((prevData) => ({
            ...prevData,
            multichoicelist4: categoryId,
        }));
    };
    const handleMultiCheckbox5Change = (event) => {
        const checkedId = parseInt(event.target.value);

        let categoryId = [];
        if (event.target.checked){
            setSelectedIds5([...selectedIds5,checkedId])
            categoryId = [...selectedIds5,checkedId];
        } else {
            setSelectedIds5(selectedIds5.filter(id=>id !== checkedId))
            categoryId = selectedIds5.filter(id=>id !== checkedId)
        }

        setInputs((prevData) => ({
            ...prevData,
            multichoicelist5: categoryId,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const decimalKeys = [
            "decimal1",
            "decimal2",
            "decimal3",
            "decimal4",
            "decimal5",
        ];

        const integerKeys = [
            "integer1",
            "integer2",
            "integer3",
            "integer4",
            "integer5",
        ];
    
        decimalKeys.forEach((key) => {
            if (inputs[key] !== undefined && !isNaN(parseFloat(inputs[key]))) {
                inputs[key] = parseFloat(inputs[key])
                inputs[key] = inputs[key].toFixed(2); // Ensures number format
            }
        });
        integerKeys.forEach((key) => {
            if (inputs[key] !== undefined && !isNaN(parseFloat(inputs[key]))) {
                inputs[key] = parseInt(inputs[key]); // Ensures number format
            }
        });
    
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to update task")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {  
                setButtonLoading(true);
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');

                axios.post(baseUrl+"/api/Task/UpdateTask", inputs, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    }
                }).then((response) => {
                    if(response.success === "1") {
                        Swal.fire({
                            title: `${ t("updated")}!`,
                            text: `${ t("task updated")}!`,
                            icon: "success"
                        });
                    }
                    setButtonLoading(false);
                }).catch((error) => {
                    console.log(error);
                    setButtonLoading(false);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });
    };

    return (
        <div>
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}>
                <div className="space-y-2 sm:space-y-4">
                    {/* first box */}
                    <div className="flex justify-between items-center">
                        <div>
                            <h1 className="sm:text-2xl font-semibold capitalize">{ t('Edit Task') }</h1>
                            <p className="text-light-400 text-xs sm:text-sm capitalize"><NavLink to={`/profiles/task/${customerId}`}>{ t('customer task list') }</NavLink>/{ t('edit task') }</p>
                        </div>
                        {!buttonLoading && (
                            <NavLink to={`/profiles/task/${customerId}`}>
                                <div className="bg-black-100 flex items-center p-3 rounded-lg">
                                    <img src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                                </div>
                            </NavLink>
                        )}
                    </div>
                    { isLoader
                    ?
                        <LoaderIcon />
                    :
                        <form onSubmit={(e) => handleSubmit(e)} className="space-y-4">
                            <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4">
                                    {Boolean(taskTemplate.isCodeVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('code')}
                                            </div>
                                            <input type="text" name="code" value={inputs.code} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isFromDateVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('from date')}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.fromDate, 'MM/DD/YYYY')} name={'fromdate'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isToDateVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('to date')}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.todate, 'MM/DD/YYYY')} name={'todate'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isFromTimeVisible) && 
                                        (<div>
                                            <div className="font-semibold text-sm capitalize">
                                                { t('from time')}
                                            </div>
                                            <TimePickerComponent sendTimeFromChild={handleTimeDataFromChild} timeInput={taskTemplate.fromTime} name={'fromtime'} />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isToTimeVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('to time')}
                                            </div>
                                            <TimePickerComponent sendTimeFromChild={handleTimeDataFromChild} timeInput={taskTemplate.toTime} name={'totime'} />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDurationVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('duration')}
                                            </div>
                                            <input type="number" name="duration" value={inputs.duration} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isLibraryVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('library')}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowLibrary(!showLibrary)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.libraryName) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.libraryName ? inputs.libraryName : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showLibrary
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.libraryList && taskTemplate.libraryList.map((library, index) => (
                                                                <li key={`library${index}`} onClick={(e) => handleLibrary((e), library)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{library.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isCategoryVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('category')}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowCategory(!showCategory)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.taskCategoryName) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.taskCategoryName ? inputs.taskCategoryName : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showCategory
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.categoryList && taskTemplate.categoryList.map((category, index) => (
                                                                <li key={`category${index}`} onClick={(e) => handleCategory((e), category)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{category.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    
                                    {Boolean(taskTemplate.isImportanceVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('importance')}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowImportance(!showImportance)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.importanceName) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.importanceName ? inputs.importanceName : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showImportance
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.importanceList && taskTemplate.importanceList.map((importance, index) => (
                                                                <li key={`importance${index}`} onClick={(e) => handleImportance((e), importance)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{importance.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isOutComeVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('out come')}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowOutCome(!showOutCome)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.outComeName) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.outComeName ? inputs.outComeName : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showOutCome
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.outComeList && taskTemplate.outComeList.map((outCome, index) => (
                                                                <li key={`outCome${index}`} onClick={(e) => handleOutCome((e), outCome)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{outCome.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isRateVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('rate')}
                                            </div>
                                            <input type="text" name="rate" value={inputs.rate} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isSinglValueCaptionVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.singleValueCaption}
                                            </div>
                                            <input type="number" name="singlevalue" value={inputs.singleValue} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                
                                    {Boolean(taskTemplate.isDate1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.date1Caption}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.date1, 'MM/DD/YYYY')} name={'date1value'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDate2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.date2Caption}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.date2, 'MM/DD/YYYY')} name={'date2value'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDate3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.date3Caption}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.date3, 'MM/DD/YYYY')} name={'date3value'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDate4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.date4Caption}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.date4, 'MM/DD/YYYY')} name={'date4value'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDate5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.date5Caption}
                                            </div>
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs(taskTemplate.date5, 'MM/DD/YYYY')} name={'date4value'}/>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMasterList1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.masterList1Caption}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowMasterList1(!showMasterList1)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.mastersublist1value && inputs.mastersublist1value !== 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.mastersublist1value && inputs.mastersublist1value !== 0) ? inputs.masterList1Name : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showMasterList1
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.masterList && taskTemplate.masterList.map((master1, index) => (
                                                                <li key={`master1${index}`} onClick={(e) => handleMasterList1(e, master1)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{master1.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMasterList2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.masterList2Caption}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowMasterList2(!showMasterList2)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.mastersublist2value && inputs.mastersublist2value !== 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.mastersublist2value && inputs.mastersublist2value !== 0) ? inputs.masterList2Name : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showMasterList2
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.masterList && taskTemplate.masterList.map((master2, index) => (
                                                                <li key={`master2${index}`} onClick={(e) => handleMasterList2(e, master2)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{master2.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMasterList3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.masterList3Caption}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowMasterList3(!showMasterList3)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.mastersublist3value && inputs.mastersublist3value !== 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.mastersublist3value && inputs.mastersublist3value !== 0) ? inputs.masterList3Name : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showMasterList3
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.masterList && taskTemplate.masterList.map((master3, index) => (
                                                                <li key={`master3${index}`} onClick={(e) => handleMasterList3(e, master3)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{master3.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMasterList4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.masterList4Caption}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowMasterList4(!showMasterList4)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.mastersublist4value && inputs.mastersublist4value !== 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.mastersublist4value && inputs.mastersublist4value !== 0) ? inputs.masterList4Name : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showMasterList4
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.masterList && taskTemplate.masterList.map((master4, index) => (
                                                                <li key={`master4${index}`} onClick={(e) => handleMasterList4(e, master4)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{master4.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMasterList5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.masterList5Caption}
                                            </div>
                                            <div className="relative inline-block w-full">
                                                <button onClick={(e) => setShowMasterList5(!showMasterList5)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                    <span className={(inputs.mastersublist5value && inputs.mastersublist5value !== 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.mastersublist5value && inputs.mastersublist5value !== 0) ? inputs.masterList5Name : 'select'}</span>
                                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showMasterList5
                                                    ? 
                                                        <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                            {taskTemplate.masterList && taskTemplate.masterList.map((master5, index) => (
                                                                <li key={`master5${index}`} onClick={(e) => handleMasterList5(e, master5)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{master5.title}</li>
                                                            ))}
                                                        </ul>  
                                                    : null
                                                }
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isComplitionLevelVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('complition level')}
                                            </div>
                                            <input type="number" name="complitionlevel" value={inputs.complitionLevel} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMultiChoice1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.multiChoice1Caption}
                                            </div>
                                            {taskTemplate.multiChoice1Type === 1 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice1(!showMultiChoice1)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist1.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.multichoicelist1.length > 0) ? taskTemplate.MultiChoiceTypeList1Name : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice1
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                                {taskTemplate.multiChoiceList1.map((choiceList1, index) => (
                                                                    <li key={`multiChoiceList1${index}`} onClick={(e) => handleMultiChoiceTypeList1(e, choiceList1)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{choiceList1.title}</li>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                            {taskTemplate.multiChoice1Type === 2 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice1(!showMultiChoice1)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist1.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.multichoicelist1.length > 0) ? 'selected' : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice1
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full px-4">
                                                                {taskTemplate.multiChoiceList1.map((choiceList1, index) => (
                                                                    <div key={`multiChoiceList1${index}`} className="flex items-center my-3">
                                                                        <label className="relative flex items-center cursor-pointer">
                                                                            <input type="checkbox" name={choiceList1.title} value={choiceList1.id} defaultChecked={(inputs.multichoicelist1 && inputs.multichoicelist1.includes(choiceList1.id)) ? true : false} onChange={(event) => handleMultiCheckbox1Change(event)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </label>
                                                                        <div className="font-normal text-xs sm:text-base ml-2 text-light-400">{choiceList1.title}</div>
                                                                    </div>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMultiChoice2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.multiChoice2Caption}
                                            </div>
                                            {taskTemplate.multiChoice2Type === 1 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice2(!showMultiChoice2)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist2.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.multichoicelist2.length > 0 ? inputs.MultiChoiceTypeList2Name : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice2
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                                {taskTemplate.multiChoiceList2.map((choiceList2, index) => (
                                                                    <li key={`multiChoiceList2${index}`} onClick={(e) => handleMultiChoiceTypeList2(e, choiceList2)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{choiceList2.title}</li>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                            {taskTemplate.multiChoice2Type === 2 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice2(!showMultiChoice2)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist2.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.multichoicelist2.length > 0) ? 'selected' : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice2
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full px-4">
                                                                {taskTemplate.multiChoiceList2.map((choiceList2, index) => (
                                                                    <div key={`multiChoiceList2${index}`} className="flex items-center my-3">
                                                                        <label className="relative flex items-center cursor-pointer">
                                                                            <input type="checkbox" name={choiceList2.title} value={choiceList2.id} defaultChecked={(inputs.multichoicelist2 && inputs.multichoicelist2.includes(choiceList2.id)) ? true : false} onChange={(event) => handleMultiCheckbox2Change(event)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </label>
                                                                        <div className="font-normal text-xs sm:text-base ml-2 text-light-400">{choiceList2.title}</div>
                                                                    </div>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMultiChoice3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.multiChoice3Caption}
                                            </div>
                                            {taskTemplate.multiChoice3Type === 1 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice3(!showMultiChoice3)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist3.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.multichoicelist3.length > 0 ? inputs.MultiChoiceTypeList3Name : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice3
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                                {taskTemplate.multiChoiceList3.map((choiceList3, index) => (
                                                                    <li key={`multiChoiceList3${index}`} onClick={(e) => handleMultiChoiceTypeList3(e, choiceList3)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{choiceList3.title}</li>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                            {taskTemplate.multiChoice3Type === 2 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice3(!showMultiChoice3)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist3.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.multichoicelist3.length > 0) ? 'selected' : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice3
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full px-4">
                                                                {taskTemplate.multiChoiceList3.map((choiceList3, index) => (
                                                                    <div key={`multiChoiceList3${index}`} className="flex items-center my-3">
                                                                        <label className="relative flex items-center cursor-pointer">
                                                                            <input type="checkbox" name={choiceList3.title} value={choiceList3.id} defaultChecked={(inputs.multichoicelist3 && inputs.multichoicelist3.includes(choiceList3.id)) ? true : false} onChange={(event) => handleMultiCheckbox3Change(event)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </label>
                                                                        <div className="font-normal text-xs sm:text-base ml-2 text-light-400">{choiceList3.title}</div>
                                                                    </div>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMultiChoice4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.multiChoice4Caption}
                                            </div>
                                            {taskTemplate.multiChoice4Type === 1 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice4(!showMultiChoice4)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist4.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.multichoicelist4.length > 0 ? inputs.MultiChoiceTypeList4Name : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice4
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                                {taskTemplate.multiChoiceList4.map((choiceList4, index) => (
                                                                    <li key={`multiChoiceList4${index}`} onClick={(e) => handleMultiChoiceTypeList4(e, choiceList4)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{choiceList4.title}</li>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                            {taskTemplate.multiChoice4Type === 2 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice4(!showMultiChoice4)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist4.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.multichoicelist4.length > 0) ? 'selected' : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice4
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full px-4">
                                                                {taskTemplate.multiChoiceList4.map((choiceList4, index) => (
                                                                    <div key={`multiChoiceList4${index}`} className="flex items-center my-3">
                                                                        <label className="relative flex items-center cursor-pointer">
                                                                            <input type="checkbox" name={choiceList4.title} value={choiceList4.id} defaultChecked={(inputs.multichoicelist4 && inputs.multichoicelist4.includes(choiceList4.id)) ? true : false} onChange={(event) => handleMultiCheckbox4Change(event)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </label>
                                                                        <div className="font-normal text-xs sm:text-base ml-2 text-light-400">{choiceList4.title}</div>
                                                                    </div>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isMultiChoice5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.multiChoice5Caption}
                                            </div>
                                            {taskTemplate.multiChoice5Type === 1 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice5(!showMultiChoice5)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist5.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{inputs.multichoicelist5.length > 0 ? inputs.MultiChoiceTypeList5Name : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice5
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full">
                                                                {taskTemplate.multiChoiceList5.map((choiceList5, index) => (
                                                                    <li key={`multiChoiceList5${index}`} onClick={(e) => handleMultiChoiceTypeList5(e, choiceList5)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{choiceList5.title}</li>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                            {taskTemplate.multiChoice5Type === 2 && (
                                                <div className="relative inline-block w-full">
                                                    <button onClick={(e) => setShowMultiChoice5(!showMultiChoice5)} type="button" className="bg-white border-2 border-black-100 text-gray-dark justify-between font-normal p-3 w-full rounded-md inline-flex items-center space-x-3">
                                                        <span className={(inputs.multichoicelist5.length > 0) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{(inputs.multichoicelist5.length > 0) ? 'selected' : 'select'}</span>
                                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                                    </button>
                                                    {
                                                        showMultiChoice5
                                                        ? 
                                                            <ul className="absolute z-30 bg-white shadow-md top-14 right-0 rounded-md w-full px-4">
                                                                {taskTemplate.multiChoiceList5.map((choiceList5, index) => (
                                                                    <div key={`multiChoiceList5${index}`} className="flex items-center my-3">
                                                                        <label className="relative flex items-center cursor-pointer">
                                                                            <input type="checkbox" name={choiceList5.title} value={choiceList5.id} defaultChecked={(inputs.multichoicelist5 && inputs.multichoicelist5.includes(choiceList5.id)) ? true : false} onChange={(event) => handleMultiCheckbox5Change(event)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </label>
                                                                        <div className="font-normal text-xs sm:text-base ml-2 text-light-400">{choiceList5.title}</div>
                                                                    </div>
                                                                ))}
                                                            </ul>  
                                                        : null
                                                    }
                                                </div>
                                            )}
                                        </div>)
                                    }
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-4">
                                    {Boolean(taskTemplate.isText1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.text1Caption}
                                            </div>
                                            <input type="text" name="text1value" value={inputs.text1value}  onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isText2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.text2Caption}
                                            </div>
                                            <input type="text" name="text2value" value={inputs.text2value}  onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isText3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.text3Caption}
                                            </div>
                                            <input type="text" name="text3value" value={inputs.text3value}  onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isText4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.text4Caption}
                                            </div>
                                            <input type="text" name="text4value" value={inputs.text4value}  onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isText5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.text5Caption}
                                            </div>
                                            <input type="text" name="text5value" value={inputs.text5value} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isInteger1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.integer1Caption}
                                            </div>
                                            <input type="number" name="integer1" value={inputs.integer1} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isInteger2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.integer2Caption}
                                            </div>
                                            <input type="number" name="integer2" value={inputs.integer2} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isInteger3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.integer3Caption}
                                            </div>
                                            <input type="number" name="integer3" value={inputs.integer3} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isInteger4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.integer4Caption}
                                            </div>
                                            <input type="number" name="integer4" value={inputs.integer4} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isInteger5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.integer5Caption}
                                            </div>
                                            <input type="number" name="integer5" value={inputs.integer5} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDecimal1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.decimal1Caption}
                                            </div>
                                            <input type="number" name="decimal1" value={inputs.decimal1} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDecimal2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.decimal2Caption}
                                            </div>
                                            <input type="number" name="decimal2" value={inputs.decimal2} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDecimal3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.decimal3Caption}
                                            </div>
                                            <input type="number" name="decimal3" value={inputs.decimal3} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDecimal4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.decimal4Caption}
                                            </div>
                                            <input type="number" name="decimal4" value={inputs.decimal4} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDecimal5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.decimal5Caption}
                                            </div>
                                            <input type="number" name="decimal5" value={inputs.decimal5} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                                    {Boolean(taskTemplate.isCommentsVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('commets')}
                                            </div>
                                            <input type="text" name="comments" value={inputs.comments} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isDescriptionVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                { t('description')}
                                            </div>
                                            <input type="text" name="description" value={inputs.description} onChange={handleChange} className="border-black-100 focus:outline-none bg-white border-2 rounded-lg p-3 w-full placeholder:capitalize" placeholder="enter" />
                                        </div>)
                                    }
                                </div>
                                <div className="grid grid-cols-1 gap-2 sm:gap-4">
                                    {Boolean(taskTemplate.isYesNoCaptionVisible) && 
                                        (<div className="space-y-2">
                                            <div className="font-semibold text-sm capitalize">
                                                {taskTemplate.yesNoCaption}
                                            </div>
                                            <div className="flex space-x-4">
                                                <div className="inline-flex items-center space-x-2">
                                                    <label className="relative flex items-center cursor-pointer" htmlFor="yes">
                                                        <input
                                                            name='yesno'
                                                            type="radio"
                                                            className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-400 checked:border-blue-normal bg-white transition-all"
                                                            id="yes"
                                                            value={'true'}
                                                            checked={inputs.yesno === 'true'}
                                                            onChange={handleChange}
                                                        />
                                                        <span className="absolute bg-blue-normal w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                                                    </label>
                                                    <div className="capitalize">
                                                        { t("yes")}
                                                    </div>
                                                </div>
                                                <div className="inline-flex items-center space-x-2">
                                                    <label className="relative flex items-center cursor-pointer" htmlFor="no">
                                                        <input
                                                            name='yesno'
                                                            type="radio"
                                                            className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-400 checked:border-blue-normal bg-white transition-all"
                                                            id="no"
                                                            value={'false'}
                                                            checked={inputs.yesno == 'false'}
                                                            onChange={handleChange}
                                                        />
                                                        <span className="absolute bg-blue-normal w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                                                    </label>
                                                    <div className="capitalize">
                                                        { t("no")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isCheckBox1Visible) && 
                                        (<div className="space-y-2">
                                            <div className="flex items-center">
                                                <label className="relative flex items-center cursor-pointer">
                                                    <input name="checkboxvalue1" type="checkbox" checked={inputs.checkboxvalue1 === 1} onChange={handleChange} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </label>
                                                <div className="font-normal text-sm sm:text-base ml-2 text-light-400">{taskTemplate.checkBox1Caption}</div>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isCheckBox2Visible) && 
                                        (<div className="space-y-2">
                                            <div className="flex items-center">
                                                <label className="relative flex items-center cursor-pointer">
                                                    <input name="checkboxvalue2" type="checkbox" checked={inputs.checkboxvalue2 === 1} onChange={handleChange} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </label>
                                                <div className="font-normal text-sm sm:text-base ml-2 text-light-400">{taskTemplate.checkBox2Caption}</div>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isCheckBox3Visible) && 
                                        (<div className="space-y-2">
                                            <div className="flex items-center">
                                                <label className="relative flex items-center cursor-pointer">
                                                    <input name="checkboxvalue3" type="checkbox" checked={inputs.checkboxvalue3 === 1} onChange={handleChange} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </label>
                                                <div className="font-normal text-sm sm:text-base ml-2 text-light-400">{taskTemplate.checkBox3Caption}</div>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isCheckBox4Visible) && 
                                        (<div className="space-y-2">
                                            <div className="flex items-center">
                                                <label className="relative flex items-center cursor-pointer">
                                                    <input name="checkboxvalue4" type="checkbox" checked={inputs.checkboxvalue4 === 1} onChange={handleChange} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </label>
                                                <div className="font-normal text-sm sm:text-base ml-2 text-light-400">{taskTemplate.checkBox4Caption}</div>
                                            </div>
                                        </div>)
                                    }
                                    {Boolean(taskTemplate.isCheckBox5Visible) && 
                                        (<div className="space-y-2">
                                            <div className="flex items-center">
                                                <label className="relative flex items-center cursor-pointer">
                                                    <input name="checkboxvalue5" type="checkbox" checked={inputs.checkboxvalue5 === 1} onChange={handleChange} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </label>
                                                <div className="font-normal text-sm sm:text-base ml-2 text-light-400">{taskTemplate.checkBox5Caption}</div>
                                            </div>
                                        </div>)
                                    }
                                </div>
                                {Boolean(taskTemplate.isPhotoVisible) && 
                                    (<div className="space-y-2">
                                        <div className="font-semibold text-sm capitalize">
                                            { t('photo')}
                                        </div>
                                        <div className="flex flex-col w-fit items-center">
                                            <label htmlFor="photo" className="border-dashed border border-gray-dark rounded-lg flex flex-col justify-center items-center w-40 h-40 cursor-pointer">
                                                <img className={(imagePreview ? "" : "w-6 h-6") + " cursor-pointer rounded-lg"} src={imagePreview ? imagePreview : "../../../assets/icons/profile/camera.svg"} />
                                                {imagePreview ? "" : <div className="text-blue-normal capitalize font-semibold">{ t('add image')}</div>}
                                                <input id="photo" name="photo" type="file" className="hidden" onChange={handleImageChange} />
                                            </label>
                                            {error1 && <p className="text-red-normal text-xs font-semibold">{error1}</p>}
                                        </div>
                                    </div>)
                                }
                                {Boolean(taskTemplate.isAttachmentsVisible) && 
                                    (<div className="space-y-2 ">
                                        <div className="font-semibold text-sm capitalize">
                                            {t('attachment')}
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4 items-center">
                                            <div>
                                                <div className={"flex flex-col justify-center items-center  border-gray-normal border border-dashed rounded-lg cursor-pointer"}>
                                                    <label htmlFor="attachment" className="w-full py-4 px-4 cursor-pointer">
                                                        <div className="flex items-center space-x-2 cursor-pointer justify-center">
                                                            <img src="../../../assets/icons/profile/plus.svg" alt="plus" />
                                                            <div className="font-medium first-letter:capitalize">{t('choose file')}</div>
                                                        </div>
                                                        <input id="attachment" type="file" name="attachment" className="hidden" multiple onChange={handleFileInputChange} />
                                                    </label>
                                                </div>
                                                {error && <p className="text-red-normal text-[10px] font-semibold">{error}</p>}
                                            </div>
                                            {files.length > 0 ?
                                                    files.map((file, index) => (
                                                        <div key={index} className="shadow-md bg-gray-dark3 rounded-lg cursor-pointer p-4 space-y-2 flex justify-between items-center">
                                                            <div className="flex items-center space-x-2 text-sm">
                                                                <img className="w-6 h-6" src="../../../assets/icons/profile/upload_file.svg" alt="upload_file" />
                                                                <div>{file.filename}</div>
                                                            </div>
                                                            <div>
                                                                <img onClick={() => removeFile(index)} className="cursor-pointer w-6 h-6" src="../../../assets/icons/profile/trash.svg" alt="trash" />
                                                            </div>
                                                        </div>
                                                    ))
                                                : null
                                            }
                                        </div>
                                    </div>)
                                }
                                <div className="flex justify-end items-center space-x-4">
                                    {!buttonLoading && (
                                        <NavLink to={`/profiles/task/${customerId}`}>
                                            <button type="button" className="text-center px-4 font-medium py-1.5 text-light-400 bg-white border border-light-400 rounded-lg tracking-wide capitalize text-sm">{ t('close') }</button>
                                        </NavLink>
                                    )}
                                    <button type={buttonLoading ? "button" : "submit"} className={(buttonLoading ? "cursor-wait" : "cursor-pointer") +" text-white bg-blue-normal border-blue-normal text-center px-4 text-sm font-medium py-1.5 border rounded-lg tracking-wide capitalize"}>{buttonLoading ? (t('Please wait')+'...') : t('update task') }</button>
                                </div>
                            </div>
                        </form>
                    }
                </div>
            </Layout>
            {showWarningPopUp && <WarningPopUp customerId={customerId} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default EditTask;